import { Injectable } from '@angular/core';
import { Manager } from '../models/manager.model';
import { NapiService } from 'src/app/services/napi.service';
import { RequesterService } from 'src/app/services/requester.service';
import {AllScorecardInfo, TopStatisticsInfo} from '../models/ai-scorecard-statistic.model';
import { AiScenario, UserAiStatistics } from '../models/top-level-statistic.model';

@Injectable({
  providedIn: 'root'
})
export class ManagerDashboardService {
  constructor(
    private napi: NapiService,
    private requester: RequesterService
  ) {}

  public async getManagers(managerId: number=0): Promise<Manager[]> {
    let endpoint = 'getMyManagersList';
    if (managerId) {
      endpoint += '?manager_id=' + managerId;
    }

    const res = await this.requester.get(endpoint);
    return res.result;
  }

  public async getAllScenarios(): Promise<AiScenario[]> {
    return await this.napi.get('ai-scorecard-statistic/ai-scenarios');
  }

  public async getMyTeam(): Promise<UserAiStatistics[]> {
    return await this.napi.get('ai-scorecard-statistic/manager-team');
  }

  public async getTeamByManagerId(managerId: string): Promise<UserAiStatistics[]> {
    return await this.napi.get(`ai-scorecard-statistic/manager-team/${managerId}`);
  }

  public async getCallsForLearner(userId: string): Promise<any[]> {
    return await this.napi.get(`aicoach/calls-for-user/${userId}`);
  }

  public async getCallDetails(callId: string): Promise<any> {
    return await this.napi.get(`aicoach/call-details/${callId}`);
  }

  public async getDashboardTopStats(params: { users: string[]; aiAgents: number[] }): Promise<TopStatisticsInfo> {
    return await this.napi.post('ai-scorecard-statistic/manager-team-statistics', params);
  }

  public async getDashboardScorecardStats(params: { users: string[]; aiAgents: number[] }): Promise<AllScorecardInfo> {
    return await this.napi.post('ai-scorecard-statistic/manager-ai-scorecard-dashboard', params);
  }
}
